module.exports = __webpack_public_path__ + "img/file.d785d74.png";